import { CSSProperties } from 'react';

// ===========================================
// STILI MOBILE DRAWER
// Questi stili sono inline per bypassare
// i conflitti con Ant Design
// ===========================================

export const drawerStyles = {
  body: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column' as const,
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  header: { 
    display: 'none' 
  },
  content: {
    background: 'linear-gradient(180deg, #010D69 0%, #010a52 100%)',
  },
};

export const drawerContentStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden',
};

// ===========================================
// STILI NAVIGAZIONE MOBILE
// ===========================================

export const mobileNavStyles = {
  container: {
    flex: '1 1 auto',
    minHeight: 0,
    padding: '12px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '4px',
    overflowY: 'auto' as const,
    overflowX: 'hidden' as const,
  } as CSSProperties,

  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    minHeight: '48px',
    padding: '12px 16px',
    margin: 0,
    border: 'none',
    borderRadius: '10px',
    background: 'transparent',
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '15px',
    fontWeight: 500,
    fontFamily: 'inherit',
    cursor: 'pointer',
    textAlign: 'left' as const,
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    outline: 'none',
    boxSizing: 'border-box' as const,
    flexShrink: 0,
  } as CSSProperties,

  itemActive: {
    background: 'linear-gradient(90deg, #0D12F2 0%, #EB2ADD 100%)',
    color: '#ffffff',
    fontWeight: 600,
    boxShadow: '0 4px 16px rgba(235, 42, 221, 0.25)',
  } as CSSProperties,

  icon: {
    fontSize: '20px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '20px',
  } as CSSProperties,

  divider: {
    height: '1px',
    minHeight: '1px',
    background: 'rgba(255, 255, 255, 0.08)',
    margin: '8px 0',
    border: 'none',
    flexShrink: 0,
  } as CSSProperties,
};

// ===========================================
// STILI MENU LINGUA
// ===========================================

export const langMenuStyles = {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: '48px',
    padding: '12px 16px',
    margin: 0,
    border: 'none',
    borderRadius: '10px',
    background: 'transparent',
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '15px',
    fontWeight: 500,
    fontFamily: 'inherit',
    cursor: 'pointer',
    textAlign: 'left' as const,
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    outline: 'none',
    boxSizing: 'border-box' as const,
    flexShrink: 0,
  } as CSSProperties,

  buttonOpen: {
    background: 'rgba(255, 255, 255, 0.08)',
  } as CSSProperties,

  leftContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  } as CSSProperties,

  code: {
    fontSize: '12px',
    color: '#EB2ADD',
    fontWeight: 600,
    textTransform: 'uppercase' as const,
  } as CSSProperties,

  submenu: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '2px',
    padding: '4px 0 4px 36px',
    flexShrink: 0,
  } as CSSProperties,

  option: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 16px',
    margin: 0,
    border: 'none',
    borderRadius: '8px',
    background: 'transparent',
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'inherit',
    cursor: 'pointer',
    textAlign: 'left' as const,
    width: '100%',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    outline: 'none',
    boxSizing: 'border-box' as const,
  } as CSSProperties,

  optionActive: {
    background: 'rgba(235, 42, 221, 0.15)',
    color: '#EB2ADD',
    fontWeight: 600,
  } as CSSProperties,

  checkIcon: {
    fontSize: '14px',
  } as CSSProperties,
};

// ===========================================
// HELPER PER MERGE STILI
// ===========================================

export const mergeStyles = (...styles: (CSSProperties | false | undefined)[]): CSSProperties => {
  return styles.reduce<CSSProperties>((acc, style) => {
    if (style) {
      return { ...acc, ...style };
    }
    return acc;
  }, {});
};